import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    fetchStationDetailsAction,
    stationSelectors,
} from 'wanderu-ducks-stations';

import DirectionsMap from '../../components/DirectionsMap/DirectionsMap';
import Events from '../../events/DirectionsEvents';

class DirectionsMapContainer extends Component {
    trackEvent = () => {
        const {
            nearby,
            departStationId,
            tripId,
            type,
            waypointType,
        } = this.props;

        Events.externalDirectionsLinkClicked({
            nearby,
            stationId: departStationId,
            tripId,
            type,
            waypointType,
        });
    };

    render() {
        const {
            arriveLoading,
            arriveStation,
            arriveSuccess,
            departLoading,
            departStation,
            departSuccess,
            ...otherProps
        } = this.props;

        return (
            <DirectionsMap
                arriveLoading={arriveLoading}
                arriveStation={arriveStation}
                arriveSuccess={arriveSuccess}
                departLoading={departLoading}
                departStation={departStation}
                departSuccess={departSuccess}
                trackEvent={this.trackEvent}
                {...otherProps}
            />
        );
    }
}

DirectionsMapContainer.propTypes = {
    arriveLoading: PropTypes.bool,
    arriveStation: PropTypes.shape({
        loc: PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number,
        }),
    }),
    arriveStationId: PropTypes.string,
    arriveSuccess: PropTypes.bool,
    departLoading: PropTypes.bool.isRequired,
    departStation: PropTypes.shape({
        loc: PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number,
        }),
    }),
    departStationId: PropTypes.string.isRequired,
    departSuccess: PropTypes.bool.isRequired,
    nearby: PropTypes.bool,
    tripId: PropTypes.string,
    type: PropTypes.string.isRequired,
    waypointType: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
    const {
        arriveStationId,
        departStationId,
    } = ownProps;
    const arriveLoading = fetchStationDetailsAction.selectWorking(state, arriveStationId);
    const arriveSuccess = fetchStationDetailsAction.selectSuccess(state, arriveStationId);
    const departLoading = fetchStationDetailsAction.selectWorking(state, departStationId);
    const departSuccess = fetchStationDetailsAction.selectSuccess(state, departStationId);

    return {
        arriveLoading,
        arriveStation: stationSelectors.selectStationDetails(state, arriveStationId),
        arriveSuccess,
        departLoading,
        departStation: stationSelectors.selectStationDetails(state, departStationId),
        departSuccess,
    };
}

const mapDispatchToProps = {
    fetchStationDetails: fetchStationDetailsAction.fetch,
};

export { DirectionsMap };
export default connect(mapStateToProps, mapDispatchToProps)(DirectionsMapContainer);
